/**
 * @desc 导出SKU供需平衡
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.supplyDemandBalance.exportBySku.Params, options?: any) {
  return updateResponse(
    http(URL + `/wms/supplyDemandBalance/sku/export`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
